// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/preferences/v4/preferences.proto (package wisetime.user.preferences.v4, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/preferences/v4/preferences.proto.
 */
export const file_wisetime_user_preferences_v4_preferences: GenFile = /*@__PURE__*/
  fileDesc("Ci53aXNldGltZS91c2VyL3ByZWZlcmVuY2VzL3Y0L3ByZWZlcmVuY2VzLnByb3RvEhx3aXNldGltZS51c2VyLnByZWZlcmVuY2VzLnY0Ik8KJVNlYXJjaFJlY2VudE1hbnVhbFRpbWVDb21tZW50c1JlcXVlc3QSEQoJcGFnZV9zaXplGAEgASgNEhMKC3NlYXJjaF90ZXJtGAIgASgJIkYKJlNlYXJjaFJlY2VudE1hbnVhbFRpbWVDb21tZW50c1Jlc3BvbnNlEhwKFG1hbnVhbF90aW1lX2NvbW1lbnRzGAEgAygJIpsBCh1TZWFyY2hSZWNlbnROYXJyYXRpdmVzUmVxdWVzdBIPCgdzaXRlX2lkGAEgASgJEhEKCXBhZ2Vfc2l6ZRgCIAEoDRITCgtzZWFyY2hfdGVybRgDIAEoCRIaCg10aW1lX2dyb3VwX2lkGAUgASgJSACIAQFCEAoOX3RpbWVfZ3JvdXBfaWRKBAgEEAVSDWFjdGl2aXR5X3R5cGUiYwoeU2VhcmNoUmVjZW50TmFycmF0aXZlc1Jlc3BvbnNlEkEKCm5hcnJhdGl2ZXMYASADKAsyLS53aXNldGltZS51c2VyLnByZWZlcmVuY2VzLnY0LlJlY2VudE5hcnJhdGl2ZSI1Cg9SZWNlbnROYXJyYXRpdmUSDwoHc2l0ZV9pZBgBIAEoCRIRCgluYXJyYXRpdmUYAiABKAkiZwocRGVsZXRlUmVjZW50TmFycmF0aXZlUmVxdWVzdBJHChByZWNlbnRfbmFycmF0aXZlGAEgASgLMi0ud2lzZXRpbWUudXNlci5wcmVmZXJlbmNlcy52NC5SZWNlbnROYXJyYXRpdmUyxQMKElByZWZlcmVuY2VzU2VydmljZRKrAQoeU2VhcmNoUmVjZW50TWFudWFsVGltZUNvbW1lbnRzEkMud2lzZXRpbWUudXNlci5wcmVmZXJlbmNlcy52NC5TZWFyY2hSZWNlbnRNYW51YWxUaW1lQ29tbWVudHNSZXF1ZXN0GkQud2lzZXRpbWUudXNlci5wcmVmZXJlbmNlcy52NC5TZWFyY2hSZWNlbnRNYW51YWxUaW1lQ29tbWVudHNSZXNwb25zZRKTAQoWU2VhcmNoUmVjZW50TmFycmF0aXZlcxI7Lndpc2V0aW1lLnVzZXIucHJlZmVyZW5jZXMudjQuU2VhcmNoUmVjZW50TmFycmF0aXZlc1JlcXVlc3QaPC53aXNldGltZS51c2VyLnByZWZlcmVuY2VzLnY0LlNlYXJjaFJlY2VudE5hcnJhdGl2ZXNSZXNwb25zZRJrChVEZWxldGVSZWNlbnROYXJyYXRpdmUSOi53aXNldGltZS51c2VyLnByZWZlcmVuY2VzLnY0LkRlbGV0ZVJlY2VudE5hcnJhdGl2ZVJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHlCQQokY29tLndpc2V0aW1lLmFwaS51c2VyLnByZWZlcmVuY2VzLnY0QhdQcmVmZXJlbmNlc1NlcnZpY2VQcm90b1ABYgZwcm90bzM", [file_google_protobuf_empty]);

/**
 * @generated from message wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest
 */
export type SearchRecentManualTimeCommentsRequest = Message<"wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest"> & {
  /**
   * @generated from field: uint32 page_size = 1;
   */
  pageSize: number;

  /**
   * Optionally use a search term as prefix match for recent manual time comments.
   *
   * @generated from field: string search_term = 2;
   */
  searchTerm: string;
};

/**
 * Describes the message wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.
 * Use `create(SearchRecentManualTimeCommentsRequestSchema)` to create a new message.
 */
export const SearchRecentManualTimeCommentsRequestSchema: GenMessage<SearchRecentManualTimeCommentsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_preferences_v4_preferences, 0);

/**
 * @generated from message wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse
 */
export type SearchRecentManualTimeCommentsResponse = Message<"wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse"> & {
  /**
   * @generated from field: repeated string manual_time_comments = 1;
   */
  manualTimeComments: string[];
};

/**
 * Describes the message wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.
 * Use `create(SearchRecentManualTimeCommentsResponseSchema)` to create a new message.
 */
export const SearchRecentManualTimeCommentsResponseSchema: GenMessage<SearchRecentManualTimeCommentsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_preferences_v4_preferences, 1);

/**
 * @generated from message wisetime.user.preferences.v4.SearchRecentNarrativesRequest
 */
export type SearchRecentNarrativesRequest = Message<"wisetime.user.preferences.v4.SearchRecentNarrativesRequest"> & {
  /**
   * Filter by site.
   *
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * Maximum number of recent narratives to return.
   *
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;

  /**
   * Optionally use a search term as prefix match for recent narratives.
   *
   * @generated from field: string search_term = 3;
   */
  searchTerm: string;

  /**
   * Optionally include time_group_id to enhance search results based on timesheet fields and tags.
   *
   * @generated from field: optional string time_group_id = 5;
   */
  timeGroupId?: string;
};

/**
 * Describes the message wisetime.user.preferences.v4.SearchRecentNarrativesRequest.
 * Use `create(SearchRecentNarrativesRequestSchema)` to create a new message.
 */
export const SearchRecentNarrativesRequestSchema: GenMessage<SearchRecentNarrativesRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_preferences_v4_preferences, 2);

/**
 * @generated from message wisetime.user.preferences.v4.SearchRecentNarrativesResponse
 */
export type SearchRecentNarrativesResponse = Message<"wisetime.user.preferences.v4.SearchRecentNarrativesResponse"> & {
  /**
   * In descending order of last_used_time.
   *
   * @generated from field: repeated wisetime.user.preferences.v4.RecentNarrative narratives = 1;
   */
  narratives: RecentNarrative[];
};

/**
 * Describes the message wisetime.user.preferences.v4.SearchRecentNarrativesResponse.
 * Use `create(SearchRecentNarrativesResponseSchema)` to create a new message.
 */
export const SearchRecentNarrativesResponseSchema: GenMessage<SearchRecentNarrativesResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_preferences_v4_preferences, 3);

/**
 * A RecentNarrative is created or updated when the user posts a time group with a narrative.
 *
 * @generated from message wisetime.user.preferences.v4.RecentNarrative
 */
export type RecentNarrative = Message<"wisetime.user.preferences.v4.RecentNarrative"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string narrative = 2;
   */
  narrative: string;
};

/**
 * Describes the message wisetime.user.preferences.v4.RecentNarrative.
 * Use `create(RecentNarrativeSchema)` to create a new message.
 */
export const RecentNarrativeSchema: GenMessage<RecentNarrative> = /*@__PURE__*/
  messageDesc(file_wisetime_user_preferences_v4_preferences, 4);

/**
 * @generated from message wisetime.user.preferences.v4.DeleteRecentNarrativeRequest
 */
export type DeleteRecentNarrativeRequest = Message<"wisetime.user.preferences.v4.DeleteRecentNarrativeRequest"> & {
  /**
   * @generated from field: wisetime.user.preferences.v4.RecentNarrative recent_narrative = 1;
   */
  recentNarrative?: RecentNarrative;
};

/**
 * Describes the message wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.
 * Use `create(DeleteRecentNarrativeRequestSchema)` to create a new message.
 */
export const DeleteRecentNarrativeRequestSchema: GenMessage<DeleteRecentNarrativeRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_preferences_v4_preferences, 5);

/**
 * Resources of the Preferences service API include:
 *
 * - user/recent-narratives/*
 *
 *
 * @generated from service wisetime.user.preferences.v4.PreferencesService
 */
export const PreferencesService: GenService<{
  /**
   * @generated from rpc wisetime.user.preferences.v4.PreferencesService.SearchRecentManualTimeComments
   */
  searchRecentManualTimeComments: {
    methodKind: "unary";
    input: typeof SearchRecentManualTimeCommentsRequestSchema;
    output: typeof SearchRecentManualTimeCommentsResponseSchema;
  },
  /**
   * @generated from rpc wisetime.user.preferences.v4.PreferencesService.SearchRecentNarratives
   */
  searchRecentNarratives: {
    methodKind: "unary";
    input: typeof SearchRecentNarrativesRequestSchema;
    output: typeof SearchRecentNarrativesResponseSchema;
  },
  /**
   * Delete recent narrative of current user from provided site. Returns OK status even if nothing was removed.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    If any required field is absent
   * - PERMISSION_DENIED:   If user is not a member of provided site
   *
   * @generated from rpc wisetime.user.preferences.v4.PreferencesService.DeleteRecentNarrative
   */
  deleteRecentNarrative: {
    methodKind: "unary";
    input: typeof DeleteRecentNarrativeRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wisetime_user_preferences_v4_preferences, 0);

